import { Group, Badge, NumberFormatter, Text, Tooltip, Stack } from "@mantine/core";

function CacheTooltip({ usage, children }) {
  if (!usage.cachedTokensIn && !usage.cacheCreationTokens) {
    return children;
  }
  const nonCached = Math.max(
    0,
    usage.tokensIn - (usage.cachedTokensIn || 0) - (usage.cacheCreationTokens || 0)
  );
  return (
    <Tooltip
      withArrow
      label={
        <Stack gap={2}>
          <Text fz="xs" fw={600}>Input breakdown</Text>
          <Text fz="xs">
            Non-cached: <NumberFormatter thousandSeparator value={nonCached} />
          </Text>
          <Text fz="xs">
            Cache read: <NumberFormatter thousandSeparator value={usage.cachedTokensIn} />
          </Text>
          {usage.cacheCreationTokens > 0 && (
            <Text fz="xs">
              Cache write: <NumberFormatter thousandSeparator value={usage.cacheCreationTokens} />
            </Text>
          )}
        </Stack>
      }
    >
      {children}
    </Tooltip>
  );
}

export default function UsageDetails({ usage }) {
  if (!usage) {
    return null;
  }
  return (
    <Group>
      <Text fz="xs">Tokens</Text>
      <CacheTooltip usage={usage}>
        <Badge size="xs" radius="sm" variant="dot" color="grape">
          In: <NumberFormatter thousandSeparator value={usage.tokensIn} />
        </Badge>
      </CacheTooltip>
      <Badge size="xs" radius="sm" variant="dot" color="green">
        Out: <NumberFormatter thousandSeparator value={usage.tokensOut} />
      </Badge>
      {usage.reasoningTokens && (
        <Badge size="xs" radius="sm" variant="dot" color="blue">
          Reasoning:{" "}
          <NumberFormatter thousandSeparator value={usage.reasoningTokens} />
        </Badge>
      )}
      {usage.tokensTotal && (
        <Badge size="xs" radius="sm" variant="dot" color="black">
          Total: <NumberFormatter thousandSeparator value={usage.tokensTotal} />
        </Badge>
      )}
      {usage.webSearchRequests > 0 && (
        <Badge size="xs" radius="sm" variant="dot" color="orange">
          Searches: {usage.webSearchRequests}
        </Badge>
      )}
      {usage.toolCost > 0 && (
        <Badge size="xs" radius="sm" variant="dot" color="yellow">
          Tools:{" "}
          <NumberFormatter
            thousandSeparator
            value={usage.toolCost * 100}
            fixedDecimalScale={true}
            decimalScale={2}
            suffix=" ¢"
          />
        </Badge>
      )}
    </Group>
  );
}
